import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Active, ActiveButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_ACTIVE_BUTTONS, EDGE_ACTIVE_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeActiveButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={ActiveButton} span={EDGE_ACTIVE_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn active color="primary" className="btn-pill" id="Tooltip-29">{Active}</Btn>
        <ToolTip target="Tooltip-29" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary active</ToolTip>
        {EDGE_ACTIVE_BUTTONS_LIST.map((data, index) => (
          <CommonEdgeButton key={index} item={data} active />
        ))}
      </CardBody>
    </Card>
  );
};

export default EdgeActiveButtons;
